import Layout from "../../elements/layout";

export default function BiodataPage() {
  const currentUser = window.sakinahPublic.currentUser;
  console.log(currentUser);

  return (
    <Layout>
      <div className="sk-py-2 sk-pl-5 sk-pr-7 sk-w-full">
        <div>
          <h2 className="sk-text-xl sk-font-semibold sk-mb-0">Biodata</h2>
          <p className="sk-text-sm sk-text-neutral-400 sk-font-semibold">
            Edit biodata anda disini
          </p>
        </div>
        <div className="sk-mt-4 sk-grid lg:sk-grid-cols-2 sk-gap-[20px]">
          <div className="">
            <label
              htmlFor="first_name"
              className="sk-mb-3 sk-text-[14px] sk-block sk-font-semibold"
            >
              Nama Depan
            </label>
            <input
              type="text"
              id="first_name"
              name="first_name"
              placeholder="Input Nama depan anda"
              required
              defaultValue={currentUser.firstName}
              className="sk-w-full sk-bg-neutral-50/80 sk-px-[14px] sk-py-[12px] !sk-border-transparent !sk-shadow-none focus:!sk-shadow-none focus:!sk-border-transparent !sk-rounded-[10px] sk-text-[14px] placeholder:sk-font-medium focus:sk-bg-neutral-100 placeholder:sk-text-neutral-400 focus:!sk-ring-0 !sk-outline-0 focus:!sk-outline-0 sk-transition-colors"
            />
          </div>
          <div className="">
            <label
              htmlFor="last_name"
              className="sk-mb-3 sk-text-[14px] sk-block sk-font-semibold"
            >
              Nama Belakang
            </label>
            <input
              type="text"
              id="last_name"
              name="last_name"
              placeholder="Input Nama belakang anda"
              required
              defaultValue={currentUser.lastName}
              className="sk-w-full sk-bg-neutral-50/80 sk-px-[14px] sk-py-[12px] !sk-border-transparent !sk-shadow-none focus:!sk-shadow-none focus:!sk-border-transparent !sk-rounded-[10px] sk-text-[14px] placeholder:sk-font-medium focus:sk-bg-neutral-100 placeholder:sk-text-neutral-400 focus:!sk-ring-0 !sk-outline-0 focus:!sk-outline-0 sk-transition-colors"
            />
          </div>
          <div className="">
            <label
              htmlFor="username"
              className="sk-mb-3 sk-text-[14px] sk-block sk-font-semibold"
            >
              Username
            </label>
            <input
              type="text"
              id="username"
              name="username"
              placeholder="Input Nama belakang anda"
              required
              defaultValue={currentUser.username}
              className="sk-w-full sk-bg-neutral-50/80 sk-px-[14px] sk-py-[12px] !sk-border-transparent !sk-shadow-none focus:!sk-shadow-none focus:!sk-border-transparent !sk-rounded-[10px] sk-text-[14px] placeholder:sk-font-medium focus:sk-bg-neutral-100 placeholder:sk-text-neutral-400 focus:!sk-ring-0 !sk-outline-0 focus:!sk-outline-0 sk-transition-colors"
            />
          </div>
          <div className="">
            <label
              htmlFor="email"
              className="sk-mb-3 sk-text-[14px] sk-block sk-font-semibold"
            >
              Alamat Email
            </label>
            <input
              type="text"
              id="email"
              name="email"
              placeholder="Input Alamat email anda"
              required
              defaultValue={currentUser.email}
              className="sk-w-full sk-bg-neutral-50/80 sk-px-[14px] sk-py-[12px] !sk-border-transparent !sk-shadow-none focus:!sk-shadow-none focus:!sk-border-transparent !sk-rounded-[10px] sk-text-[14px] placeholder:sk-font-medium focus:sk-bg-neutral-100 placeholder:sk-text-neutral-400 focus:!sk-ring-0 !sk-outline-0 focus:!sk-outline-0 sk-transition-colors"
            />
          </div>
          <div className="">
            <label
              htmlFor="phone"
              className="sk-mb-3 sk-text-[14px] sk-block sk-font-semibold"
            >
              No. Handphone
            </label>
            <input
              type="text"
              id="phone"
              name="phone"
              placeholder="Input No. Handphone anda"
              required
              defaultValue={currentUser.phone}
              className="sk-w-full sk-bg-neutral-50/80 sk-px-[14px] sk-py-[12px] !sk-border-transparent !sk-shadow-none focus:!sk-shadow-none focus:!sk-border-transparent !sk-rounded-[10px] sk-text-[14px] placeholder:sk-font-medium focus:sk-bg-neutral-100 placeholder:sk-text-neutral-400 focus:!sk-ring-0 !sk-outline-0 focus:!sk-outline-0 sk-transition-colors"
            />
          </div>
          <div className="">
            <label
              htmlFor="place_of_birth"
              className="sk-mb-3 sk-text-[14px] sk-block sk-font-semibold"
            >
              Tempat Lahir
            </label>
            <input
              type="text"
              id="place_of_birth"
              name="place_of_birth"
              placeholder="Input tempat lahir anda"
              defaultValue={currentUser.placeOfBirth}
              className="sk-w-full sk-bg-neutral-50/80 sk-px-[14px] sk-py-[12px] !sk-border-transparent !sk-shadow-none focus:!sk-shadow-none focus:!sk-border-transparent !sk-rounded-[10px] sk-text-[14px] placeholder:sk-font-medium focus:sk-bg-neutral-100 placeholder:sk-text-neutral-400 focus:!sk-ring-0 !sk-outline-0 focus:!sk-outline-0 sk-transition-colors"
            />
          </div>
          <div className="">
            <label
              htmlFor="date_of_birth"
              className="sk-mb-3 sk-text-[14px] sk-block sk-font-semibold"
            >
              Tanggal Lahir
            </label>
            <input
              type="date"
              id="date_of_birth"
              name="date_of_birth"
              placeholder="Input tanggal lahir anda"
              defaultValue={currentUser.dateOfBirth}
              className="sk-w-full sk-bg-neutral-50/80 sk-px-[14px] sk-py-[12px] !sk-border-transparent !sk-shadow-none focus:!sk-shadow-none focus:!sk-border-transparent !sk-rounded-[10px] sk-text-[14px] placeholder:sk-font-medium focus:sk-bg-neutral-100 placeholder:sk-text-neutral-400 focus:!sk-ring-0 !sk-outline-0 focus:!sk-outline-0 sk-transition-colors"
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}
